import { IOrderRepository } from "../business/IOrderRepository";
// import User from "../business/Order";
import ApiService from "../../core/presentation/services/ApiService";
import { injectable } from "inversify-sugar";
import { filter } from "lodash";

@injectable()
class OrderRepository implements IOrderRepository {
  public async getUnits(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("vehicle/units", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getVehicleTypes(query?: { page?: number; limit?: number; allowBid?: boolean; input?: string }): Promise<any> {
    try {
      const { page, limit = 10, allowBid, input } = query || {};
      let endPoint = "";
      if (!!page && !!limit) {
        endPoint = `?page=${page}&limit=${limit}`;
        if (!!input) {
          endPoint += `&search=${input}`;
        }
        if (!!allowBid) {
          endPoint += `&allowBid=${allowBid}`;
        }
      } else if (!!allowBid) {
        endPoint += `?allowBid=${allowBid}`;
      }
      const response: any = await ApiService.getPost(`order/vehicle-types` + endPoint, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateVehicleType(query: { vehicleTypeId: number; allowBid: boolean }): Promise<void> {
    try {
      await ApiService.updatePost(`order/allow-bid`, query);
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async putSubmitOrder(values: any, orderId: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`order/identify-vehicle/${orderId}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllPickupLocations(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/location/pickup", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllOrders(status?: string, page?: number, input?: string, filter?: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(status && page ? `order?status=${status}&page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : status ? `order?status=${status}&search=${input}${filter ? `&${filter}` : ""}` : page ? `order?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `order${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getBidHistory(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/bid-history", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getPaidBidCancel(page: number, input: string, filter: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/order/paid-bid/cancel/v2?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `order/paid-bid/cancel${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public rebid = async (values: any): Promise<any> => {
    try {
      const response: any = await ApiService.setPost("order/rebid", values);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public async getOrderDetail(id: any, deletePrev?: boolean): Promise<any> {
    try {
      const response: any = await ApiService.getPost(!!deletePrev ? `order/${id}?deletePrev=true` : `order/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async orderCancelShipper(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`order/cancel/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getBidRequests(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`order/bid-request/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateOrder(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`order/specification/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllDeliveryLocations(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/location/delivery", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async placeOrder(values: any, action?: string): Promise<any> {
    try {
      const response: any = await ApiService.setPost(action ? `order?action=${action}` : "order", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public getShipperBids = async (): Promise<any> => {
    try {
      const response: any = await ApiService.getPost("order/bids", "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public shipperAcceptBids = async (bidId: number): Promise<any> => {
    try {
      const response: any = await ApiService.getPost(`order/accept-bid/v2/${bidId}`, "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public getCoords = async (values: any): Promise<any> => {
    try {
      const response: any = await ApiService.setPost(`vehicle/coords`, values);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public async getDigitalContractWithBidRequest(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`order/digital-contract/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async acknowledgeDigitalContract(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("order/digital-contract-acknowledgement", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateDraftOrder(id: number, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`order/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async cancelRequestShipper(orderNumber: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`order/${orderNumber}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getNewRequest(page?: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page ? `order/request/new?page=${page}&limit=10` : "order/request/new", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAcceptedRequest(page?: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page ? `order/request/accepted?page=${page}&limit=10` : "order/request/accepted", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getRequestAndOrder(status?: string, page?: number, input?: string, filter?: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(status && page ? `order/requestandorder?status=${status}&page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : status ? `order/requestandorder?status=${status}${filter ? `&${filter}` : ""}` : page ? `order/requestandorder?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `order/requestandorder${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async updateRequestAndOrder(vehicleSpecificationId: number, values: { offerPrice: string; contractRate: string; remarks: string }): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`order/specification/${vehicleSpecificationId}/approval-pending`, values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public getBidList = async (vehicleSpecId: number): Promise<any> => {
    try {
      const response: any = await ApiService.getPost(`order/vehicle-specification/${vehicleSpecId}`, "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  //delete order or cancel order
  public async cancelOrder(orderId: any): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`order/${orderId}`, "");

      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async extendExpiry(id: number): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`order/extend-expiry-time/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  // Transaction Policy
  public async getTransactionPolicy(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/transaction-policy", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateTransactionPolicy(policyId: number, values: { timeBeforePickup: string; refundPercentage: number }): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`order/transaction-policy/${policyId}`, values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getApplicablePolicy(vehicleSpecificationId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`order/applicable-policy/${vehicleSpecificationId}`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getRefundRequests(page?: number, input?: string, filter?: string): Promise<any> {
    try {
      // Start with base endpoint
      let endpoint = "order/refund-request";

      // Build query string starting with filter
      const queryParams = [];

      // Add filter first if it exists
      if (filter) {
        queryParams.push(filter);
      }

      // Add page and limit
      if (page) {
        queryParams.push(`page=${page}&limit=10`);
      }

      // Add search if it exists
      if (input) {
        queryParams.push(`search=${input}`);
      }

      // Construct final endpoint with query string
      if (queryParams.length > 0) {
        endpoint += "?" + queryParams.join("&");
      }

      const response: any = await ApiService.getPost(endpoint, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async acceptRefundRequest(id: number | number[]): Promise<any> {
    try {
      // Ensure we're sending a flat array of numbers, not a nested array

      const response: any = await ApiService.updatePost(`order/refund-request`, {
        refundIds: id, // This will be [1, 2] instead of [1, 2]
        // status: "accepted"
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async rejectRefundRequest(id: number, declinedReason: string): Promise<any> {
    try {
      // Ensure we're sending a flat array of numbers, not a nested array
      const refundIds = Array.isArray(id) ? id : [id];

      const response: any = await ApiService.updatePost(`order/refund-request`, {
        refundIds, // This will be [1, 2] instead of [1, 2]
        status: "cancelled",
        declinedReason,
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async completeRefundRequest(id: number): Promise<any> {
    try {
      // Ensure we're sending a flat array of numbers, not a nested array
      const refundIds = Array.isArray(id) ? id : [id];

      const response: any = await ApiService.updatePost(`order/refund-request`, {
        refundIds, // This will be [1, 2] instead of [1, 2]
        status: "completed",
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async submitRefundRequest(data: { documentId: number; additionalDetails: string; refundIds: number[] }): Promise<any> {
    try {
      const response: any = await ApiService.updatePost("order/refund-request", data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // Subscription Policy
  public async getSubscriptionPolicy(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("subscription/subscription-policy", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateSubscriptionPolicy(policyId: number, values: { timeBeforeExpiry: string; refundPercentage: number }): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`subscription/subscription-policy/${policyId}`, values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getSubscriptionRefundRequests(page?: number, input?: string, filter?: string): Promise<any> {
    try {
      // Start with base endpoint
      let endpoint = "subscription/refund-request";

      // Build query string starting with filter
      const queryParams = [];

      // Add filter first if it exists
      if (filter) {
        queryParams.push(filter);
      }

      // Add page and limit
      if (page) {
        queryParams.push(`page=${page}&limit=10`);
      }

      // Add search if it exists
      if (input) {
        queryParams.push(`search=${input}`);
      }

      // Construct final endpoint with query string
      if (queryParams.length > 0) {
        endpoint += "?" + queryParams.join("&");
      }

      const response: any = await ApiService.getPost(endpoint, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async accepSubscriptionRefundRequest(id: number | number[]): Promise<any> {
    try {
      // Ensure we're sending a flat array of numbers, not a nested array

      const response: any = await ApiService.updatePost(`subscription/refund-request`, {
        refundIds: id, // This will be [1, 2] instead of [1, 2]
        // status: "accepted"
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public updateRuleStatus(title: string, isActive: boolean) {
    try {
      return ApiService.setPost(`rule/status`, { title, isActive });
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public getRuleStatus() {
    try {
      return ApiService.getPost(`rule/status`, "");
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
export default OrderRepository;
